import { render, staticRenderFns } from "./nextsteps.vue?vue&type=template&id=a0aab04e&"
import script from "./nextsteps.vue?vue&type=script&lang=js&"
export * from "./nextsteps.vue?vue&type=script&lang=js&"
import style0 from "./nextsteps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports